angular.module('charts')
  .directive("standards", function() {
    return {
      restrict: "E",
      scope: {
        grades: '=',
        domains: '=',
        item: '='
      },
      transclude: true,
      templateUrl: '/resources/charts/partials/standards.html',
      controller: [
          '$scope',
          '$element',
          '$rootScope',
          '$state',
          'standard',
          'customer',
          '$timeout',
          'moment',
          'configuration',
          'authentication',
          'dblAnalyticsProvider',
          'edxDateTimeService',
          'edxUxPreferenceService',
          'translateFilter',
        function(
           $scope,
           $element,
           $rootScope,
           $state,
           $standard,
           $customer,
           $timeout,
           $moment,
           $configuration,
           dblAuthentication,
           $analytics,
           dateTimeService,
           uxPreferenceService,
           translateFilter)
      {
        $scope.CAROUSEL_ITEM_WIDTH = 148;

        $scope.UX_VIEW_KEY = uxPreferenceService.registeredPreferences.classroomStandardsView.key;
        $scope.UX_GRID_VIEW_NAME = uxPreferenceService.registeredPreferences.classroomStandardsView.views.grid;
        $scope.UX_GROUP_VIEW_NAME = uxPreferenceService.registeredPreferences.classroomStandardsView.views.group;

        $scope.treatment1Display = translateFilter('standards.grid');
        $scope.treatment2Display = translateFilter('standards.group');

        // TODO: don't set selected on $scope.grades. This seems brittle since it relies on grades being already defined here.
        $scope.grades.selected = {};
        $scope.selectedDomainId = null;
        $scope.customerStandard = $customer.getAcademicStandard();

        $scope.standardsGridEnabled = $configuration.isFeatureEnabled('standards_grid_enabled');

        $scope.showPercents = false;

        $scope.getUxView = function() {
          if (uxPreferenceService.isLoaded()) {
            if ($scope.standardsGridEnabled) {
              return uxPreferenceService.getPreference($scope.UX_VIEW_KEY, $scope.UX_GRID_VIEW_NAME);
            } else {
              return $scope.UX_GROUP_VIEW_NAME;
            }
          } else {
            return '';
          }
        };

        $scope.$watch('item', function() {
          if ($scope.item && $scope.item.type === 'classroom') {
            $scope.tabDescription = translateFilter('standards.tabDescription');
          } else {
            $scope.tabDescription = translateFilter('standards.altTabDescription');
          }
        });

        $scope.onViewTypeSelected = function() {
          $rootScope.$broadcast('viewTypeSelected');
          $rootScope.$broadcast('carouselReload');
        };

        $scope.$watch('grades', function(newVal, oldVal) {
          if (newVal && newVal.length) {
            $scope.gradesLoaded();
          }
        });

        $scope.getProficiencyDate = function() {
          if ($rootScope.reportDates) {
            return $moment($rootScope.reportDates.to_date).format('LL');
          }
          return "";
        };

        $scope.getProficiencyDateDayOfTheWeek = function() {
          if ($rootScope.reportDates) {
            return dateTimeService.dayOfWeekOrToday($rootScope.reportDates.to_date);
          }
          return "";
        };

        $scope.showProficiencyDate = function () {
          var domainsExist = $scope.domains && $scope.domains.length > 0;
          var gradesExist = $scope.grades && $scope.grades.length > 0;

          return (domainsExist || gradesExist) && $rootScope.reportDates && $scope.getUxView() !== $scope.UX_GRID_VIEW_NAME;
        };

        $scope.$on('domainsLoaded', function(e, data) {
          var selectedDomain = {};

          $standard.updateSelectedDomain(data.domains);

          var params = $standard.getParams();
          if (params.domain) {
            selectedDomain = _.findWhere(data.domains, { code: String(params.domain) });
          } else {
            selectedDomain = _.findWhere(data.domains, { queryParamSelected: true }) || _.findWhere(data.domains, {selected: true});
          }

          $scope.selectedDomainId = selectedDomain ? selectedDomain.code : null;

          $standard.updateQueryParams({ domain: $scope.selectedDomainId });
          $rootScope.$broadcast('carouselReload');
        });

        $scope.$on('onNavToggle', function() {
          $timeout(function() {
            $rootScope.$broadcast('carouselReload');
          }, 300);
        });

        $scope.$on('gradesLoaded', $scope.gradesLoaded);
        $scope.gradesLoaded = function() {

          $standard.updateSelectedGrade($scope.grades);

          var params = $standard.getParams();

          if (params.grade) {
            $scope.grades.selected = _.findWhere($scope.grades, { id: String(params.grade) });
          } else {
            $scope.grades.selected = _.findWhere($scope.grades, { queryParamSelected: true }) || _.findWhere($scope.grades, {curricular_grade_level: true});
          }

          // Ensure a grade displays
          if (_.isUndefined($scope.grades.selected)) {
            if ($scope.grades.display_grade) {
              $scope.grades.selected = _.find($scope.grades, function(o) { return o.grade === $scope.grades.display_grade; });
            } else {
              $scope.grades.selected = $scope.grades[0];
            }
          }

          var gradeId = $scope.grades.selected ? $scope.grades.selected.id : $scope.grades[0].id;
          $standard.updateQueryParams({ grade: gradeId });

          $timeout(function() {
            $scope.$emit('loadDomains');
            $scope.$emit('loadStandards');
          });

        };

        $scope.gradeClicked = function(grade) {
          $scope.grades.selected = grade;
          var gradeId = $scope.grades.selected ? $scope.grades.selected.id : undefined;
          $standard.resetQueryParams({ grade: gradeId });
          $analytics.eventTrack('Select Grade', {category: 'Resource Used', label: grade.name} );

          $timeout(function() {
            $element.find('input').blur();
            $scope.$emit('loadDomains');
            $scope.$emit('loadStandards');
          });
        };

        $scope.domainClicked = function(domain) {
          var params = $standard.getParams();
          $standard.resetQueryParams({ grade: params.grade, domain: domain.code });
          $scope.selectedDomainId = domain.code;
          $timeout(function() {
            if ($scope.selectedDomainId === '0') {
              $scope.$emit('loadDomains');
            } else {
              $scope.$emit('loadStandards');
            }
          });
        };

        // Utilities for grade select control
        $scope.MIN_CELL_WIDTH = 106;

        $scope.getMinWidth = function(){
          return $scope.grades.length * $scope.MIN_CELL_WIDTH;
        };

        $scope.getCellWidth = function (){
          var totalColumns = $scope.grades.length;
          var percent = Math.floor(100.0 * (100.0 / totalColumns)) / 100.0;
          return percent + "%";
        };
      }]
    };
  });
